import { render, staticRenderFns } from "./car-colors.vue?vue&type=template&id=4f8428ea&scoped=true"
import script from "./car-colors.vue?vue&type=script&lang=js"
export * from "./car-colors.vue?vue&type=script&lang=js"
import style0 from "./car-colors.vue?vue&type=style&index=0&id=4f8428ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8428ea",
  null
  
)

export default component.exports